module.exports = __webpack_public_path__ + "static/media/transfer.0f66c1b.wav";


//////////////////
// WEBPACK FOOTER
// ./static/media/transfer.wav
// module id = 8xx1
// module chunks = 1